export default import.meta.ROLLDOWN_FILE_URL_Rz_GRj4K_66I5njNJSR1iQ